var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var Field = function ($element) {
  this.element = $element;
  this.form = $(".js-form");
  this.parent = this.element.parents(".row");
  this.state = this.parent.find(".input__state");

  this.valid = bind(this.valid, this);

  this.element.on("blur", this.valid);
  this.element.on("autocomplete:close", this.valid);
};

/* --------------------------------------------
  Update the state of the field
  @Params: none
  @Returns: none
*/
Field.prototype.valid = function (e) {
  e.preventDefault();
  // Update the state
  if (this.element.val() != "") {
    this.state.removeClass("input__state--invalid");
    this.state.addClass("input__state--valid");
  } else {
    if (!this.element.hasClass("input--optionnal")) {
      this.state.removeClass("input__state--valid");
      this.state.addClass("input__state--invalid");
    }
  }

  var dependency = this.element.attr("data-dependency");

  if (dependency) {
    var dependencyValue = $("." + dependency).val();

    if (this.element.val()) {
      if (dependencyValue) {
        this.state.removeClass("input__state--invalid");
        this.state.addClass("input__state--valid");
      } else {
        this.state.removeClass("input__state--valid");
        this.state.addClass("input__state--invalid");
      }
    } else {
      if (dependencyValue) {
        this.state.removeClass("input__state--valid");
        this.state.addClass("input__state--invalid");
      } else {
        this.state.removeClass("input__state--invalid");
        this.state.removeClass("input__state--valid");
      }
    }
  }

  // Remove the state of the field if the field is optional and empty
  if (this.element.hasClass("input--optionnal") && this.element.val() == "") {
    this.state.removeClass("input__state--valid");
    this.state.removeClass("input__state--invalid");
  }

  // Test Email
  if (this.element[0].type == "email" && this.element.val() != "") {
    var pattern =
      /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

    if (pattern.test(this.element.val())) {
      this.state.removeClass("input__state--invalid");
      this.state.addClass("input__state--valid");
    } else {
      this.state.removeClass("input__state--valid");
      this.state.addClass("input__state--invalid");
    }
  }

  // Test Regex
  if (this.element.attr("data-regex") && this.element.val() != "") {
    var pattern = new RegExp(this.element.attr("data-regex"));

    if (pattern.test(this.element.val())) {
      this.state.removeClass("input__state--invalid");
      this.state.addClass("input__state--valid");

      if (this.element.attr("data-message")) {
        this.element.parent("label").removeClass("label--error");
        this.element.removeClass("input--error");
        this.element.prev(".error").html("");
      }
    } else {
      this.state.removeClass("input__state--valid");
      this.state.addClass("input__state--invalid");

      if (this.element.attr("data-message")) {
        this.element.parent("label").addClass("label--error");
        this.element.addClass("input--error");
        this.element
          .prev(".error")
          .html(" - " + this.element.attr("data-message"));
      }
    }
  }
};

module.exports = Field;
